// @flow

import { useState, useEffect } from 'react';
import { useTenant } from '@tectonics/commons/tenant';
import { useEnrollment } from '../context';
import { pollEnrollmentStatus } from '../services/enrollment-api';

type PrefillData = {|
  +bankId: ?string,
  +identification: ?string,
  +loading: boolean,
|};

export function useEnrollmentPrefill(): PrefillData {
  const tenant = useTenant();
  const { data } = useEnrollment();
  const [bankId, setBankId] = useState<?string>(null);
  const [identification, setIdentification] = useState<?string>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchPrefill() {
      try {
        const result = await pollEnrollmentStatus(data.contract, tenant.code);

        if (cancelled) return;

        const enrollment = result.enrollment;
        if (enrollment) {
          if (enrollment.bank_id) {
            setBankId(enrollment.bank_id);
          }
          if (enrollment.identification) {
            setIdentification(enrollment.identification);
          }
        }
      } catch (error) {
        if (!cancelled) {
          // eslint-disable-next-line no-console
          console.error('Failed to fetch enrollment prefill:', error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchPrefill();

    return () => { cancelled = true; };
  }, [data.contract, tenant.code]);

  return { bankId, identification, loading };
}
